import { Card, SxProps } from '@mui/material';
import { ReactNode } from 'react';

export const TabsWrapper: React.FC<{ children: ReactNode; sx?: SxProps }> = ({ children, sx }) => (
  <Card sx={{ padding: 5, pb: 5, ...sx }} elevation={0}>
    {children}
  </Card>
);
